import { Component, EventEmitter, Injectable, Injector, OnInit, Output } from '@angular/core';
import { FormBuilder, NgForm } from '@angular/forms';
import { UploadService } from '../../../../common/services/Upload.service';
import { ConfirmationService } from 'primeng/primeng';
import { Location } from '@angular/common';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { ToastrService } from 'ngx-toastr';
import { ContactService } from '../../../../common/services/Contact.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';

declare var $: any;
let that;
@Component({
  moduleId: module.id,
  selector: 'contact_add',
  templateUrl: './contact_add.component.html',
  styleUrls: ['./contact.css'],
  providers: [ConfirmationService, ContactService, EvsAddressService],
})
@Injectable()
export class ContactAddComponent implements OnInit {
  @Output('backComponent') backComponent = new EventEmitter();
  public contact: any = {};
  public message: { class: string; content: string } = null;
  public error = '';
  public cities: Array<any> = [];
  public districts: Array<any> = [];

  listType = [
    { id: 1, value: 1, label: 'Điểm bán' },
    { id: 2, value: 2, label: 'Bảo hành' },
    { id: 3, value: 3, label: 'Điểm bán + Bảo hành' },
  ];

  constructor(
    private injector: Injector,
    private _location: Location,
    private contactService: ContactService,
    public addressService: EvsAddressService,
    private upload: UploadService,
    private _fb: FormBuilder,
    private toastr: ToastrService
  ) {
    that = this;
  }

  ngOnInit() {
    this.getCity();
    $('#cities')
      .select2({
        placeholder: '-- Chọn Tỉnh/TP --',
        allowClear: false,
        width: '100%',
      })
      .on('select2:select', function (e) {
        setTimeout(() => {
          $('.select2-selection__rendered').removeAttr('title');
          const id = e.target.value;
          that.loadDistrictData(id);
        }, 100);
      });
    $('#districts')
      .select2({
        placeholder: '-- Chọn Quận/Huyện --',
        allowClear: false,
        width: '100%',
      })
      .on('select2:select', function (e) {
        $('.select2-selection__rendered').removeAttr('title');
      });
    $('.inputDate').datepicker({ format: 'yyyy-dd-mm' });
    $('#_sex').select2({ placeholder: '--Giới tính --', allowClear: false });
  }

  getCity() {
    this.addressService.getCities().subscribe(res => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  loadDistrictData(id: number) {
    this.addressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then(res => {
        const districts = [];
        res.data.districts.forEach((c: any) => {
          districts.push({
            value: c.name,
            label: c.name,
            id: c.id,
          });
        });
        this.districts = districts;
      });
  }

  onSubmit(form: NgForm) {
    this.message = null;
    let objectData = {};

    const city = $('#cities option:selected').val();
    const district = $('#districts option:selected').val();
    const birthday = $('#birthday').val();
    const sex = $('#_sex option:selected').val();
    if (this.contact.name.trim().length === 0) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên không được bỏ trống !',
      };
    } else {
      this.processSave();
      this.contact.city = $('#cities option:selected').text();
      this.contact.district = $('#districts option:selected').text();
      objectData = {
        name: this.contact.name,
        phone: this.contact.phone,
        email: this.contact.email,
        address: this.contact.address,
        facebook: this.contact.facebook,
        sex: sex,
      };
      if (city) {
        objectData['city_id'] = city;
      }

      if (district) {
        objectData['district_id'] = district;
      }
      if (birthday) {
        objectData['birthday'] = moment(birthday, 'YYYY-DD-MM').valueOf();
      }

      this.contactService.create(objectData).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.toastr.error('Thêm mới thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.resetForm(form);
              this.toastr.success('Thêm mới thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.backComponent.emit({
                isBack: false,
              });
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
    this.scrollToTop();
  }

  resetForm(frm: NgForm) {
    $('#city').val('').trigger('change');
    $('#districts').val('').trigger('change');
    $('#birthday').val('').trigger('change');
    this.contact.name = '';
    this.contact.phone = '';
    this.contact.email = '';
    this.contact.sex = '';
  }

  backToComponent() {
    this.backComponent.emit({
      isBack: true,
    });
  }

  processSave() {
    this.message = {
      class: 'alert dark alert-info',
      content: 'Đang thực thi...',
    };
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/contact/contact_add.component.ts